import Entity from './entity';
import TransferRegion from './transferRegion';
import TransferVehicle from './transferVehicle';
export default class Transfer extends Entity<string> {

      fromRegionId: string;
      fromRegion: TransferRegion;
      toRegionId: string;
      toRegion: TransferRegion;
      startDate: string;
      endDate: string;
      price: number;
      currencyId: string;
      passengerCount: number;
      baggageCount: number;
      transferVehicleId: string;
      transferVehicle: TransferVehicle;
      distance: number;
      transferDuration: string;
      isActive: boolean;
  
}
